<template>
    <div class="section-howworks">
        <div class="container">
            <div class="row justify-content-center">
                <div class="title">
                    <h2 class="h1 p-title p-black p-center mb-0 relawayBold">How it works</h2>
                </div>
            </div>
            <div class="row">
                <div class="col-md-4">
                    <div class="works-item  wave-1">
                        <div class="img p-center">
                            <img src="/img/phone.svg" alt="">
                        </div>
                        <div class="desc">
                            <p class="min p-center p-black">
                                Add your postcode and amount of power you spend per year
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="works-item  wave-2">
                        <div class="img p-center">
                            <img src="/img/scales2.svg" alt="">
                        </div>
                        <div class="desc">
                            <p class="min p-center p-black">
                                Add your postcode and amount of power you spend per year
                            </p>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="works-item">
                        <div class="img p-center">
                            <img src="/img/cash.svg" alt="">
                        </div>
                        <div class="desc">
                            <p class="min p-center p-black mb-0">
                                Add your postcode and amount of power you spend per year
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "HowWorks",
    }
</script>
